(function () {
  'use strict';

  var SLOTS = [
    '.jm-card__img', '.jm-card__img-secondary', '.card__media img', '.media > img',
    '.kl-product-card__img', '.kl-cat-card__stage img', '.kl-edsplit__media img',
    '.kl-ed-split__img img', '.kl-hero__media img', '.product__media img',
    '.sf-hs__media img', '.sf-mc__media img', '.sf-dt__media img', '.sf-rail img',
    '.sf-dm__thumb img', '.sf-dmm__thumb img', '[data-sf-fit-stage] img'
  ].join(',');
  // Never re-fit brand marks or UI imagery.
  var SKIP = '.header__heading-link img, [class*="logo"] img, img[class*="logo"], .list-payment img, [class*="trustpilot"] img, [class*="badge"] img';

  var CACHE_KEY = 'sf-imgfit:v1';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) { cache = {}; }
  function save() { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) { /* quota */ } }

  function isCatalogueSrc(u) { return /cdn\.shopify\.com|\/cdn\/shop\//.test(u || ''); }
  function baseOf(u) { return String(u || '').split('?')[0]; }
  function probeUrl(u) {
    var b = baseOf(u);
    return b + '?width=64';
  }

  function classify(src, done) {
    var key = baseOf(src);
    if (cache.hasOwnProperty(key)) { done(cache[key]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight;
        if (!w || !h) { done(null); return; }
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data;
        var ring = Math.max(2, Math.round(Math.min(w, h) * 0.04));
        var bg = 0, n = 0;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            if (x >= ring && x < w - ring && y >= ring && y < h - ring) continue;   // border ring only
            var i = (y * w + x) * 4;
            var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
            if (a < 24 || (mn >= 232 && mx - mn <= 16)) bg++;
            n++;
          }
        }
        var kind = n && bg / n >= 0.82 ? 'pack' : 'photo';
        cache[key] = kind; save();
        done(kind);
      } catch (e) { done(null); }          // tainted canvas / decode error → leave untouched
    };
    probe.onerror = function () { done(null); };
    probe.src = probeUrl(src);
  }

  function stageOf(img) {
    // Start ABOVE the image: closest() also tests the element itself.
    var p = img.parentElement;
    return (p && p.closest('.jm-card__stage, .card__media, .media, .kl-product-card__media, .kl-cat-card__stage, ' +
      '.kl-edsplit__media, .kl-ed-split__img, .kl-hero__media, .sf-hs__media, .sf-mc__media, .sf-dt__media, ' +
      '.sf-dm__thumb, .sf-dmm__thumb, [data-sf-fit-stage]')) || p;
  }

  function cropLoss(img) {
    var iw = img.naturalWidth, ih = img.naturalHeight, sw = img.clientWidth, sh = img.clientHeight;
    if (!iw || !ih || !sw || !sh) return 0;
    var ir = iw / ih, sr = sw / sh;
    return 1 - Math.min(ir / sr, sr / ir);
  }

  function apply(img) {
    if (!img || img.dataset.sfFitted || img.matches(SKIP)) return;
    var src = img.currentSrc || img.src;
    if (!isCatalogueSrc(src)) return;
    img.dataset.sfFitted = 'pending';
    classify(src, function (kind) {
      var st = stageOf(img);
      if (kind === 'pack') {
        img.dataset.sfFitted = 'pack';
        img.classList.add('sf-fit--pack');
        if (st) st.classList.add('sf-fit-stage--pack');
        return;
      }
      // A PHOTO keeps the slot's fill — unless filling would cut away a real share of the
      // product (a tall box in a wide slot lost its bottom). Then it is shown whole.
      // EXCEPT a hero WALLPAPER (a lifestyle photo behind the headline, not a product slide):
      // it must fill the banner — shown whole it left an empty grey band beside it
      // (Protealane 2026-10-03, 6016×4016 photo in a ~2.4:1 banner).
      // The same for the other LARGE scene frames (editorial splits, the spotlight): a photo with
      // its own background (a dryer in a kitchen) fills the frame — shown whole it sat between
      // grey bars (Thefutureclo 2026-10-06). Only an extreme shape mismatch (>40% cut) is kept
      // whole there. Packshots (white background) are handled above and never cropped.
      var wallpaper = img.closest('.kl-hero__slide, .kl-hero') && !img.closest('.kl-hero__slide--dept');
      var sceneFrame = !!img.closest('.kl-edsplit__media, .sf-tip__media, .kl-whyus__media');
      var loss = cropLoss(img);
      if (kind === 'photo' && loss > 0.15 && !wallpaper && !(sceneFrame && loss <= 0.4)) {
        img.dataset.sfFitted = 'whole';
        img.classList.add('sf-fit--whole');
        if (st) st.classList.add('sf-fit-stage--pack');
        return;
      }
      img.dataset.sfFitted = kind || 'unknown';
    });
  }

  function watch(img) {
    if (img.complete && img.naturalWidth) apply(img);
    else img.addEventListener('load', function () { apply(img); }, { once: true });
  }

  function scan(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll(SLOTS) : [];
    for (var i = 0; i < list.length; i++) watch(list[i]);
  }

  function start() {
    scan(document);
    // Sections rendered later (recommendations, cart drawer, quick view, AJAX filtering).
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(SLOTS)) watch(node);
            scan(node);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
